"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var config_1 = require("../config");
var callCounter = 0;
/**
 * Return a callback, the promise value and unsubscribed if component unmount
 * @param promiseCallback
 * @param deps
 * @returns function
 */
function usePromiseCallback(promiseCallback, deps) {
    var isMounted = React.useRef(true);
    var lastCall = React.useRef();
    React.useEffect(function () {
        return function () {
            isMounted.current = false;
        };
    }, []);
    return React.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var currentCall = ++callCounter;
        lastCall.current = currentCall;
        var promise = promiseCallback.apply(void 0, tslib_1.__spreadArray([function () {
                return isMounted.current && lastCall.current === currentCall;
            }], tslib_1.__read(args), false));
        promise.catch(function (err) {
            (0, config_1.getConfig)().onUnhandledError(err, 'hooks');
            throw err;
        });
        return promise;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
exports.default = usePromiseCallback;
